// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red[data-v-7217aea7] {
  color: var(--elem-red-color);
}
.color-green[data-v-7217aea7] {
  color: green;
}
.color-blue[data-v-7217aea7] {
  color: var(--toolbtn-active-color);
}
.custom-input-text[data-v-7217aea7] {
  margin-bottom: 40%;
}
.custom-input-text .custom-input-text-content[data-v-7217aea7] {
  position: absolute;
  width: 100%;
  display: flex;
  pointer-events: none;
}
.custom-input-text .custom-input-text-arrow[data-v-7217aea7] {
  pointer-events: initial;
  cursor: pointer;
  margin: 10px 2px auto auto;
  color: #aaa;
  transition-property: all;
  transition-duration: .5s;
}
.custom-input-text .custom-input-text-arrow.up[data-v-7217aea7] {
  transform: rotate(-180deg);
  transition-property: all;
  transition-duration: .5s;
}
.custom-input-text .input[data-v-7217aea7] {
  padding: initial;
  padding: 5px;
  /* text-align: center; */
  color: rgba(255, 255, 255, 0);
  caret-color: #aaa;
  transition-property: all;
  transition-duration: 1s;
  font-size: 16px;
}
.custom-input-text .input.up[data-v-7217aea7] {
  color: var(--custom-textarea-color);
  transition-property: all;
  transition-duration: .5s;
}
.custom-input-text .custom-input-text-placeholder[data-v-7217aea7] {
  pointer-events: none;
  margin: auto auto 5px 5px;
  font-size: 16px;
  position: absolute;
  color: #aaa;
  transform: translateY(5px);
  transition-property: all;
  transition-duration: .25s;
}
.custom-input-text .custom-input-text-placeholder.up[data-v-7217aea7] {
  margin: auto 5px;
  font-size: 0.9em;
  transform: translateY(-15px);
  transition-property: all;
  transition-duration: .25s;
}
.custom-input-text .custom-input-text-list[data-v-7217aea7] {
  pointer-events: initial;
  width: 112%;
  left: -6%;
  position: absolute;
  padding: 10px;
  background-color: var(--bg-color);
  border: 1px solid #ccc;
  border-radius: 10px;
  transition-property: all;
  transition-duration: .5s;
  opacity: 1;
  z-index: 1000;
  max-height: 70%;
  overflow-y: scroll;
  visibility: visible;
}
.custom-input-text .custom-input-text-list.h[data-v-7217aea7] {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition-property: all;
  transition-duration: .25s;
}
.custom-input-text .custom-input-text-list .server[data-v-7217aea7] {
  pointer-events: initial;
  cursor: pointer;
  display: flex;
}
.custom-input-text .custom-input-text-list .server[data-v-7217aea7]:not(:last-child) {
  margin-bottom: 25px;
}
.custom-input-text .custom-input-text-list .server .server-icon[data-v-7217aea7] {
  /* width: 20px;
                    height: 20px; */
  border-radius: 50%;
}
.custom-input-text .custom-input-text-list .server .server-icon.middle[data-v-7217aea7] {
  width: 50px;
  height: 50px;
}
.custom-input-text .custom-input-text-list .server .server-descr[data-v-7217aea7] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: auto 10px;
}
.custom-input-text .custom-input-text-list .server .server-descr .server-name[data-v-7217aea7] {
  color: var(--custom-textarea-color);
}
.custom-input-text .custom-input-text-list .server .server-descr .server-address[data-v-7217aea7] {
  font-size: .9em;
  color: #aaa;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/login/SelectServerInput.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE;mCACiC;EACjC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".color-red[data-v-7217aea7] {\n  color: var(--elem-red-color);\n}\n.color-green[data-v-7217aea7] {\n  color: green;\n}\n.color-blue[data-v-7217aea7] {\n  color: var(--toolbtn-active-color);\n}\n.custom-input-text[data-v-7217aea7] {\n  margin-bottom: 40%;\n}\n.custom-input-text .custom-input-text-content[data-v-7217aea7] {\n  position: absolute;\n  width: 100%;\n  display: flex;\n  pointer-events: none;\n}\n.custom-input-text .custom-input-text-arrow[data-v-7217aea7] {\n  pointer-events: initial;\n  cursor: pointer;\n  margin: 10px 2px auto auto;\n  color: #aaa;\n  transition-property: all;\n  transition-duration: .5s;\n}\n.custom-input-text .custom-input-text-arrow.up[data-v-7217aea7] {\n  transform: rotate(-180deg);\n  transition-property: all;\n  transition-duration: .5s;\n}\n.custom-input-text .input[data-v-7217aea7] {\n  padding: initial;\n  padding: 5px;\n  /* text-align: center; */\n  color: rgba(255, 255, 255, 0);\n  caret-color: #aaa;\n  transition-property: all;\n  transition-duration: 1s;\n  font-size: 16px;\n}\n.custom-input-text .input.up[data-v-7217aea7] {\n  color: var(--custom-textarea-color);\n  transition-property: all;\n  transition-duration: .5s;\n}\n.custom-input-text .custom-input-text-placeholder[data-v-7217aea7] {\n  pointer-events: none;\n  margin: auto auto 5px 5px;\n  font-size: 16px;\n  position: absolute;\n  color: #aaa;\n  transform: translateY(5px);\n  transition-property: all;\n  transition-duration: .25s;\n}\n.custom-input-text .custom-input-text-placeholder.up[data-v-7217aea7] {\n  margin: auto 5px;\n  font-size: 0.9em;\n  transform: translateY(-15px);\n  transition-property: all;\n  transition-duration: .25s;\n}\n.custom-input-text .custom-input-text-list[data-v-7217aea7] {\n  pointer-events: initial;\n  width: 112%;\n  left: -6%;\n  position: absolute;\n  padding: 10px;\n  background-color: var(--bg-color);\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  transition-property: all;\n  transition-duration: .5s;\n  opacity: 1;\n  z-index: 1000;\n  max-height: 70%;\n  overflow-y: scroll;\n  visibility: visible;\n}\n.custom-input-text .custom-input-text-list.h[data-v-7217aea7] {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition-property: all;\n  transition-duration: .25s;\n}\n.custom-input-text .custom-input-text-list .server[data-v-7217aea7] {\n  pointer-events: initial;\n  cursor: pointer;\n  display: flex;\n}\n.custom-input-text .custom-input-text-list .server[data-v-7217aea7]:not(:last-child) {\n  margin-bottom: 25px;\n}\n.custom-input-text .custom-input-text-list .server .server-icon[data-v-7217aea7] {\n  /* width: 20px;\n                    height: 20px; */\n  border-radius: 50%;\n}\n.custom-input-text .custom-input-text-list .server .server-icon.middle[data-v-7217aea7] {\n  width: 50px;\n  height: 50px;\n}\n.custom-input-text .custom-input-text-list .server .server-descr[data-v-7217aea7] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin: auto 10px;\n}\n.custom-input-text .custom-input-text-list .server .server-descr .server-name[data-v-7217aea7] {\n  color: var(--custom-textarea-color);\n}\n.custom-input-text .custom-input-text-list .server .server-descr .server-address[data-v-7217aea7] {\n  font-size: .9em;\n  color: #aaa;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
